export enum ProjectType {
  NewCompany = 1,
  ExistingCompany = 2,
}
